import ModalHeader from '../Modal/ModalHeader';
import { IonButton, IonIcon, IonModal } from '@ionic/react';
import { copyOutline, logoWhatsapp, qrCodeOutline, rocketOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import './CompletionScreen.css';

type CompletionScreenProps = {
  isOpen: boolean;
  slug: string;
  onGoHome: () => void;
};

const CompletionScreen: React.FC<CompletionScreenProps> = ({ isOpen, slug, onGoHome }) => {
  const [showQrModal, setShowQrModal] = useState(false);
  const [copied, setCopied] = useState(false);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const cardapioLink = `cliente.xeguei.com.br/?empresaid=${slug.replaceAll("empresa#", "")}`;
  const cardapioUrl = `https://${cardapioLink}`;

  useEffect(() => {
    if (isOpen) {
      // Confetti simples com canvas
      const duration = 3000;
      const end = Date.now() + duration;
      const canvas = canvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      const colors = ['#F97316', '#10B981', '#3B82F6', '#EF4444', '#8B5CF6', '#F59E0B'];
      const particles: { x: number; y: number; vx: number; vy: number; color: string; size: number; rotation: number }[] = [];

      for (let i = 0; i < 150; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height - canvas.height,
          vx: (Math.random() - 0.5) * 4,
          vy: Math.random() * 3 + 2,
          color: colors[Math.floor(Math.random() * colors.length)],
          size: Math.random() * 8 + 4,
          rotation: Math.random() * 360
        });
      }

      const animate = () => {
        if (!ctx || !canvas) return;
        if (Date.now() > end) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          return;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        particles.forEach(p => {
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate((p.rotation * Math.PI) / 180);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
          ctx.restore();
          p.x += p.vx;
          p.y += p.vy;
          p.rotation += 3;
          p.vy += 0.05;
        });
        requestAnimationFrame(animate);
      }
      animate();
    }
  }, [isOpen]);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(cardapioUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleWhatsApp = () => {
    const message = encodeURIComponent(`Olá! Agora você pode fazer seu pedido direto pelo nosso cardápio digital: ${cardapioUrl}`);
    window.open(`https://wa.me/?text=${message}`, '_blank');
  };

  const handleQrCode = () => {
    setShowQrModal(true);
  };

  return (
    <>
      <canvas
        ref={canvasRef}
        style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          pointerEvents: 'none', zIndex: 9999
        }}
      />

      <div className="completion-screen" style={{ display: isOpen ? 'flex' : 'none' }}>
        <div className="completion-content">
          <div className="completion-icon"><IonIcon color="primary" icon={rocketOutline} /></div>

          <h1 className="completion-title">
            Tudo pronto! Sua loja está ativa.
          </h1>

          <p className="completion-subtitle">
            Agora compartilhe seu cardápio e receba seu primeiro pedido!
          </p>

          <div className="completion-actions">
            <IonButton expand="block" className="completion-btn-copy" onClick={handleCopyLink}>
              <IonIcon icon={copyOutline} slot="start" />
              {copied ? 'Link copiado!' : 'Copiar link'}
            </IonButton>

            <IonButton expand="block" className="completion-btn-qr" fill="outline" onClick={handleQrCode}>
              <IonIcon icon={qrCodeOutline} slot="start" />
              Gerar QR Code
            </IonButton>

            <IonButton expand="block" className="completion-btn-whatsapp" onClick={handleWhatsApp}>
              <IonIcon icon={logoWhatsapp} slot="start" />
              Compartilhar no WhatsApp
            </IonButton>
          </div>

          <IonButton expand="block" className="completion-btn-home" fill="outline" onClick={onGoHome}>
            Ir para o início
          </IonButton>
        </div>
      </div>

      <IonModal className="xeguei-dialog onboarding-qr-modal" isOpen={showQrModal} onDidDismiss={() => setShowQrModal(false)}>
        <div className="xeguei-dialog-panel">
        <ModalHeader title="QR Code do seu cardápio" layout="compact" onDismiss={() => setShowQrModal(false)} />
        <div className="qr-modal-content xeguei-dialog-body">
          <div className="qr-code-container">
            <img
              src={`https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(cardapioUrl)}`}
              alt="QR Code"
              width={250}
              height={250}
            />
          </div>
          <p className="qr-link">{cardapioLink}</p>
          <IonButton onClick={() => setShowQrModal(false)} className="qr-close-btn">
            Fechar
          </IonButton>
        </div>
        </div>
      </IonModal>
    </>
  );
};

export default CompletionScreen;
